import { callApi } from "./Api";

export const GET_STATES = 'GET_STATES';
export const GET_TIMEZONE = 'GET_TIMEZONE';
export const GET_COMPANY_LOGO = 'GET_COMPANY_LOGO';
export const GET_PHOTO = 'GET_PHOTO';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const SET_STATUS = 'SET_STATUS';
export const UPDATE_LOGO = 'UPDATA_LOGO';
export const UPDATE_PHOTOT = 'UPDATE_PHOTO';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

export const setStatus = (value) => ({type: SET_STATUS, value})

export const getStates = () => (dispatch, getStates) => {
  let url = `commons/state-options`;
  callApi(dispatch, getStates, GET_STATES, url);
}

export const getTimezone = () => (dispatch, getStates) => {
  let url = `commons/timezone-options`;

  callApi(dispatch, getStates, GET_TIMEZONE, url);
}

export const getCompanyLogo = (id) => (dispatch, getStates) => {
  let url = `pub/clients/${id}/logo`;

  callApi(dispatch, getStates, GET_COMPANY_LOGO, url);
}

export const getPhoto = (imgFilename) => (dispatch, getStates) => {
  let url = `avatars/${imgFilename}`;

  callApi(dispatch, getStates, GET_PHOTO, url);
}

export const updateProfile = (obj) => (dispatch, getStates) => {
  let url = `users/my-profile/basic-info`;

  callApi(dispatch, getStates, UPDATE_PROFILE, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}

export const updateLogo = (id, uuid) => (dispatch, getStates) => {
  let url = `clients/${id}/logo/${uuid}`;

  callApi(dispatch, getStates, UPDATE_LOGO, url, {
    method: 'POST'
  });
}

export const updatePhoto = (uuid) => (dispatch, getStates) => {
  let url = `users/my-profile/avatar/${uuid}`;

  callApi(dispatch, getStates, UPDATE_PHOTOT, url, {
    method: 'POST'
  });
}

export const changePassword = (obj) => (dispatch, getState) => {
  let url = `users/my-profile/change-password`;
  callApi(dispatch, getState, CHANGE_PASSWORD, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}



// WEBPACK FOOTER //
// ./src/actions/Profile.js